module.exports = __webpack_public_path__ + "media/images/member/40x40-69c7f518363f4d4462f024ca2f9874d8.png";